import { useGetLoyaltyReferralCustomerQuery } from "@jti/store/slices/loyaltyApiSlice";
import { useUser } from "@jti/ui";

export type UseReferralCustomerOptions = {
  skip?: boolean;
};

export type UseReferralCustomerResult = {
  parentCode: string;
  hasFirstPurchase: boolean;
  isUserEligible: boolean;
  hasCustomerData: boolean;
  isLoading: boolean;
  user: {
    uuid: string;
    ciamToken: string;
  };
};

export const useReferralCustomer = (options?: UseReferralCustomerOptions): UseReferralCustomerResult => {
  const { user } = useUser();

  const referralCustomerQuery = useGetLoyaltyReferralCustomerQuery(
    { uuid: user?.uuid ?? "", ciam_token: user?.ciam_token ?? "" },
    { skip: options?.skip || !(user?.uuid && user?.ciam_token) }
  );

  const customerData = referralCustomerQuery.data;
  const parentCode = customerData?.parent_code || user?.parent_code || "";
  const hasFirstPurchase = Boolean(customerData?.has_first_purchase);
  const isUserEligible =
    Boolean(user?.uuid) && Boolean(user?.referrals?.can_enter_a_code || user?.referrals?.can_receive_discount);
  const hasCustomerData = Boolean(customerData) && !referralCustomerQuery.isLoading;

  return {
    parentCode,
    hasFirstPurchase,
    isUserEligible,
    hasCustomerData,
    isLoading: referralCustomerQuery.isLoading,
    user: {
      uuid: user?.uuid ?? "",
      ciamToken: user?.ciam_token ?? "",
    },
  };
};
